function numbersOnlyString(value) {
    if (!value) {
        return;
    }

    return value.replace(/\D/g, "");
}

function yesNoFromBool(value) {
    return ((value === true || value === 'true') ? 'yes' : 'no');
}

function heightFromString(heightString) {

    if (!heightString) {
        return;
    }

    var heightSplit = heightString.replace("in", "").split("ft");

    if (heightSplit.length > 0) {

        const feet = heightSplit[0].trim();
        const inches = heightSplit[1].trim();
        const heightTotalInches = (parseInt(feet, 10) * 12) + parseInt(inches, 10);


        return {
            heightFt: feet,
            heightIn: inches,
            heightTotalIn: heightTotalInches
        }
    }
}

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

function calculateBMI(totalHeightInches, weight) {
  return (weight * 703) / (totalHeightInches * totalHeightInches);
}

function isBlank(value) {
  return (!value || /^\s*$/.test(value));
}

export { numbersOnlyString, yesNoFromBool, heightFromString, calculateBMI, isBlank, formatPhoneNumber }


// WEBPACK FOOTER //
// ./src/components/Helpers/Conversion.js